import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/glyph/cross';
import { css } from '@compiled/react';
import { AdControls } from '@post-office/components--ad-controls';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { type ComponentProps, type FunctionComponent } from 'react';

type PropsWithOnDismissed = {
	onDismissed: () => void;
	whyAmISeeingThisModalContent?: ComponentProps<typeof AdControls>['whyAmISeeingThisModalContent'];
};

const DismissButton: FunctionComponent<PropsWithOnDismissed> = ({ onDismissed }) => {
	const { messageDismissed } = useMessageEvent();
	const { messageInstanceClicked } = useMessageInstanceEvent();

	return (
		<IconButton
			shape="default"
			appearance="subtle"
			label="close"
			icon={(iconProps) => <CrossIcon {...iconProps} size="small" />}
			onClick={() => {
				onDismissed();
				messageDismissed().catch(() => {});
				messageInstanceClicked({
					messageEventType: 'clicked',
					clickedElement: {
						clickIdentifier: 'close',
						clickedElement: 'button',
						buttonType: 'primary',
					},
					action: {
						actionType: 'dismiss',
					},
					additionalMetadataFromFrontend: {},
				}).catch(() => {});
			}}
		/>
	);
};

const actionsStyles = css({
	display: 'flex',
});

export const Actions: FunctionComponent<PropsWithOnDismissed> = ({
	onDismissed,
	whyAmISeeingThisModalContent,
}) => {
	return (
		<div css={actionsStyles}>
			<AdControls
				iconSize="small"
				onDismissed={onDismissed}
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
			/>
			<DismissButton onDismissed={onDismissed} />
		</div>
	);
};
